const aws = require('aws-sdk');
const vis = require('vis');
const dataUtils = require('./dataUtils.js');

aws.config.update({
  region:'us-east-1',
  accessKeyId: 'AKIAJLVWBNBCDZZT4NTA',
  secretAccessKey: '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',
});

export default function generateVisualization() {
    /**
     * Load previous data.
     * This is a little dense, but process is:
     * - Get the db result (only once so it's immutable for now)
     * - Pull the value out of the result
     * - Start a reduce based on each visitor key
     *  - For each visitor key, create a node first.
     */
  const client = new aws.DynamoDB.DocumentClient();
  client.scan({
    TableName : 'pound',
  }, (err, data) => {
    if (err) { console.log(err); return; }

    /**
     * Get the unique user IDs.
     */
    const users = new Set(
      data.Items.map((item) => item.userID)
    );
    /**
     * Create an object containing array of hashes for each user ID,
     */
    const userHashes = dataUtils.createMappingFromArray([...users], 'pageviewOutgoingHash', data.Items);

    /**
     * Create an object containing array of visits for each user ID,
     */
    const visitsByUser = dataUtils.filterFromArray([...users], 'userID', data.Items);

    /**
     * Generate nodes and edges. This process reduces over user ID.
     */
    const nodesAndEges = [...users].reduce((agg, visitorKey) => {
      /**
       * Generate array of unique titles visited by user.
       */
      const uniqueTitles = [...new Set(
        Object.keys(visitsByUser[visitorKey]).map(visit => visitsByUser[visitorKey][visit].clientGUID)
      )];

      /**
       * for each title visited by the user, we will be adding a node and edge.
       */
      uniqueTitles.forEach((title) => {

        /**
         * Get the user views to this specific title.
         */
        const userViewsToTitle = visitsByUser[visitorKey]
          .filter((pv) => title === pv.clientGUID);

        /**
         * Get the first user view to the title.
         */
        const firstView = userViewsToTitle[0];

        /**
         * Based on the first view, identify the referring user if there was one.
         */
        let referringUser = false;
        Object.keys(userHashes).forEach((user) => {
          if (Object.values(userHashes[user]).includes(firstView.pageviewIncomingHash)) {
            referringUser = user;
          }
        });

        /**
         * If there's not a referring user, make sure we have a top-level node for title.
         */
        if (!referringUser && !agg.nodes.find((node) => title === node.id)) {
          agg.nodes.push({
            label: title,
            id: title,
            group: 'post',
          });
        }
        const source = (firstView.pageviewReferrer) ? firstView.pageviewReferrer.split( '/' )[2] : 'direct';

        if (!agg.nodes.find((node) => visitorKey === node.id)) {
          agg.nodes.push({
            title,
            id: visitorKey,
            group: source,
            referringUser,
            value: userViewsToTitle.length,
            hashes: Object.values(userViewsToTitle).map((view) => view.pageviewIncomingHash ? view.pageviewIncomingHash : null)
          });
        }
        if (referringUser) {
          agg.edges.push(
            {
              from: referringUser,
              to: visitorKey,
              label: `${userViewsToTitle.length} views via ${source}`,
            }
          );
        } else {
          agg.edges.push(
            {
              from: title,
              to: visitorKey,
              dashes: true,
              label: `${userViewsToTitle.length} views via ${source}`,
            }
          );
        }
      });
      return agg;
    }, {nodes: [], edges: []});
    const options = {
      layout: {
        hierarchical: {
          direction: 'UD',
          sortMethod: 'directed',
        }
      },
      physics: {
        
      },
      groups: {
        'www.linkedin.com': {
          shape: 'image',
          image: {
            selected: './images/linkedin.png',
            unselected: './images/linkedin.png'
          },
        },
        'github.com': {
          shape: 'image',
          image: {
            selected: './images/github.png',
            unselected: './images/github.png'
          },
        },
        't.co': {
          shape: 'image',
          image: {
            selected: './images/twitter.png',
            unselected: './images/twitter.png'
          },
        },
        post: {
          shape: 'image',
          image: {
            selected: './images/d.png',
            unselected: './images/d.png'
          },
        },
        direct: {
          shape: 'image',
          image: {
            selected: './images/mario.png',
            unselected: './images/mario.png'
          },
        }
      }
    };
    new vis.Network(document.getElementById('viz'), nodesAndEges, options);
  });
}



// WEBPACK FOOTER //
// ./src/viz.js